import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "@heroicons/react/24/outline";
import {
  deleteStoreById,
  fetchAllStores,
} from "../../../../redux/reducer/storesReducer";
import StoresTableDetails from "./StoresTableDetails";
import AddStoreForm from "./AddStoreForm";

const StoresSettings = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [pricingOrder, setPricingOrder] = useState(null);
  const dispatch = useDispatch();
  const { allStores, loading, error } = useSelector((state) => state.stores);
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false); 
  const headers = [
    "ID",
    "Title EN",
    "Title AR",
    "SubTitle EN",
    "SubTitle AR",
    "Des EN",
    "Des AR",
    "image",
    "Actions",
  ];

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchAllStores());
    };

    fetchData();
  }, [dispatch]);

  const loadStore = async () => {
    try {
      await dispatch(fetchAllStores()).unwrap();
    } catch (error) {
      console.error("Failed to fetch the Stores:", error);
    }
  };

  const handleDelete = (StoreId) => {
    if (window.confirm("Are you sure you want to delete this Store?")) {
      dispatch(deleteStoreById(StoreId))
        .unwrap()
        .then(() => {
          alert(t("storeDeleted"));
          dispatch(fetchAllStores());
        })
        .catch((error) => alert(error || "Failed to delete Store."));
    }
  };

  const handleUpdate = () => {
    dispatch(fetchAllStores());
  };
  // console.log(allStores)
  return (
    <div className="mx-auto overflow-x-auto rounded-xl">
      <div className="flex justify-between my-4">
        <h1 className="text-xl font-bold text-black">Store</h1>
        <button
          className="flex gap-3 px-3 py-2 duration-300 rounded-lg bg-custom-yellow hover:bg-black group"
          onClick={() => {
            setShowForm(true);
          }}
        >
          <PlusIcon className="w-6 h-6 text-black group-hover:text-white" />
          <span className="text-black group-hover:text-white">Store</span>
        </button>
      </div>

      {loading ? (
        <p className="text-center text-gray-600">{t("Loading...")}</p>
      ) : error ? (
        <p className="text-center text-red-500">
          {t("Error")}: {error}
        </p>
      ) : allStores?.length === 0 ? (
        <p className="text-center text-gray-500">{t("No data found")}</p>
      ) : (
        <table className="w-full my-5">
          <thead>
            <tr className="text-sm text-black bg-custom-yellow">
              {headers.map((header, index) => (
                <th key={index} className="px-2 py-2 font-bold text-center">
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {allStores?.map((store, index) => (
              <StoresTableDetails
                key={store._id || index}
                index={index + 1}
                details={{
                  id: store._id,
                  number: index + 1,
                  img: store.img,
                  titleEN: store.title?.en,
                  titleAR: store.title?.ar,
                  subTitleEN: store.subTitle?.en,
                  subTitleAR: store.subTitle?.ar,
                  descEN: store.desc?.en,
                  descAR: store.desc?.ar,
                }}
                isEditing={editingOrder === store._id}
                isPricing={pricingOrder === store._id}
                setEditingOrder={setEditingOrder}
                setPricingOrder={setPricingOrder}
                onUpdate={handleUpdate}
                onDelete={() => handleDelete(store._id)}
              />
            ))}
          </tbody>
        </table>
      )}
      {showForm && (
        <AddStoreForm
          onClose={() => {
            setShowForm(false);
            loadStore();
          }}
        />
      )}
    </div>
  );
};

export default StoresSettings;
